import type React from 'react';
import { useSliderContext } from './context';

interface Props {
  title: React.ReactNode;
}

function Header({ title }: Props) {
  const { value, valToString } = useSliderContext();
  return (
    <div className="mb-10 flex justify-between">
      {title}
      <div>{valToString(value)}</div>
    </div>
  );
}

export default Header;
